import React from 'react'
import { Grid, Switcher, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const Switch = ({ label, ...rest }) => {
  return (
    <Grid fluid={false} as={'label'} gap={8} alignItems="center">
      <Switcher {...rest} />
      {label && (
        <Typography
          color={'Label-Fifth'}
          variant={'Body-15'}
          component={'span'}
        >
          {label}
        </Typography>
      )}
    </Grid>
  )
}

Switch.propTypes = {
  label: PropTypes.string,
}

export default Switch
